module.exports = __webpack_public_path__ + "img/smoke.202c56d7.svg";